import _extends from "babel-runtime/helpers/extends";
import { default as reducer, initialState } from "./reducer";
import { default as actions } from "./actions";
import { default as selectors } from "./selectors";

import { PLAY_SOUND_SESSION_STORE_SOUND, PLAY_SOUND_SESSION_START, PLAY_SOUND_SESSION_PROGRESS, PLAY_SOUND_SESSION_END } from "./constants";

var SrePlaySound = _extends({
  initialState: initialState,
  reducer: reducer,
  actions: actions,
  selectors: selectors
}, actions, selectors, {
  PLAY_SOUND_SESSION_STORE_SOUND: PLAY_SOUND_SESSION_STORE_SOUND,
  PLAY_SOUND_SESSION_START: PLAY_SOUND_SESSION_START,
  PLAY_SOUND_SESSION_PROGRESS: PLAY_SOUND_SESSION_PROGRESS,
  PLAY_SOUND_SESSION_END: PLAY_SOUND_SESSION_END
});

export default SrePlaySound;